/**
 * Where a Sales notification opens (HHNodeServer salesCrmService). A new
 * voicemail in your own mailbox, or one given to you, opens your voicemails;
 * one to the sales group opens everyone's waiting. A follow-up or issue given
 * to you, due, written on, resolved or raised opens /sales/follow-ups on the
 * right list with that one on top (`item`).
 * Shared by NotificationBell and usePushNotifications so the two agree.
 */
export function salesNotificationPath(type: string | undefined, data?: Record<string, string>): string | null {
  if (type === 'sales_voicemail_assigned' || (type === 'sales_voicemail_new' && data?.mine === '1')) {
    return '/sales?tab=voicemails&show=mine';
  }
  if (type === 'sales_voicemail_new') return '/sales?tab=voicemails';
  // Follow-ups and issues open /sales/follow-ups, which a Nursery seat can open too,
  // with the one named on top and its thread open.
  const item = data?.follow_up_id ? `&item=${encodeURIComponent(data.follow_up_id)}` : '';
  if (type === 'sales_follow_up_assigned' || type === 'sales_follow_up_due') return `/sales/follow-ups?show=mine${item}`;
  if (type === 'sales_follow_up_done') return `/sales/follow-ups?show=done${item}`;
  if (type === 'sales_issue_raised') return `/sales/follow-ups?show=open&kind=issue${item}`;
  if (type === 'sales_follow_up_update') return `/sales/follow-ups?show=open${item}`;
  return null;
}
